import styled from 'styled-components'

import { theme } from 'styles/theme'

const { media, space, zIndices, fontSizes } = theme

export const Hero = styled.section`
  position: relative;
  background-color: #f3f6ff;
  overflow: hidden;
  width: 100%;

  @media (${media.tablet}) {
    padding-top: ${space['spacing-xxxl']};
    padding-bottom: ${space['spacing-xxxl']};
  }

  @media (${media.phone}) {
    padding-top: ${space['spacing-ultra']};
  }
`

export const Infos = styled.div`
  position: relative;
  z-index: ${zIndices[1]};
  top: -${space['spacing-sm']};

  h1 {
    margin-bottom: ${space['spacing-lg']};
  }

  @media (${media.tablet}) {
    top: 0;
    margin-top: ${space['spacing-ultra']};
    margin-bottom: ${space['spacing-md']};

    > p {
      margin-bottom: ${space['spacing-md']};
    }
  }

  @media (${media.desktop}) {
    h1,
    h1 span {
      font-size: ${fontSizes['font-size-heading-2']};
    }

    > p {
      font-size: ${fontSizes['font-size-body-1']};
    }
  }
`

export const RightWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: ${space['spacing-xxl']};

  @media (${media.tablet}) {
    padding-bottom: 0;
  }
`
